import { usePage } from '@inertiajs/vue3';

export function useToast({ message, type = 'success' }: { message: string | undefined; type?: string }) {
    usePage().props.flash = {
        message,
        type,
    };
}
